import { useState } from 'react';

import { Stack } from '@mui/material';

import { PropertyForm } from '@modules/_shared/components/property-form/PropertyForm';
import { FooterActionsComponentWithoutForm } from '@modules/reports/shared/FooterActionsComponentWithoutForm';
import { PropertyAddressCompact } from '@modules/reports/shared/PropertyAddressCompact';

type PropertyDetailsDrawerProps = {
  propertyId?: string;
  onPropertyUpdate: () => void | Promise<void>;
  step: number;
  setStep: (step: number) => void;
  updating: boolean;
};

const StepPropertyDetails = ({
  propertyId,
  onPropertyUpdate,
  step,
  setStep,
  updating,
}: PropertyDetailsDrawerProps) => {
  const [isAutoSaving, setIsAutoSaving] = useState(false);

  return (
    <>
      <Stack sx={{ height: 0, overflow: 'auto', flexGrow: 1 }}>
        {propertyId != null && (
          <PropertyAddressCompact
            propertyId={propertyId}
            onPropertyUpdate={onPropertyUpdate}
          />
        )}
        <PropertyForm
          propertyId={propertyId}
          onLoadingChange={setIsAutoSaving}
          onSave={onPropertyUpdate}
          excludeCategories={['address-title', 'distances', 'meta']}
          actionButtonsComponent={<></>}
          compactMode
          collapsibleCategories={[
            { name: 'surfaces_title', count: 4 },
            { name: 'construction_title', count: 2 },
          ]}
          autoSave
          isCMA
        />
      </Stack>
      <FooterActionsComponentWithoutForm
        updating={isAutoSaving || updating}
        step={step}
        setStep={setStep}
      />
    </>
  );
};

export default StepPropertyDetails;
